import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useForm } from "react-hook-form";
import { ICertificatesTabProps } from "@components/routes/auth_routes/CustomerProfile/CustomerDetails/interface";
import ConsentForm from "../Template/ConsentForm";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import LetterHeader from "../Template/LetterHeader";
import RadiographyReport from "../Template/RadiographyReport";
import Ultrasound from "../Template/Ultrasound";
import DeathReport from "../Template/DeathReport";
import GeneralConentForm from "../Template/GeneralConentForm";
import FreedomDiseaseForm from "../Template/FreedomDiseaseForm";
import Pethelthcertificate from "../Template/Pethelthcertificate";
import Microchipping from "../Template/Microchipping";
import PetVaccinationCertificate from "../Template/PetVaccinationCertificate";
import StaralizationForm from "../Template/StaralizationForm";
import BoardingAndHospitalization from "../Template/BoardingAndHospitalization";
import PethelthcertificateNottravel from "../Template/PethelthcertificateNottravel";
import SurgeryConsentForm from "../Template/SurgeryConsentForm";
import XrayConsentForm from "../Template/XrayConsentForm";
import BloodGlucose from "../Template/BloodGlucose";
import UrinTestForm from "../Template/UrinTestForm";
import BPMesaurment from "../Template/BPMesaurment";
import Echocardiography from "../Template/Echocardiography";
import EarCytology from "../Template/EarCytology";
import SkinCytology from "../Template/SkinCytology";
import RabiesTitrePetHistoryCollection from "../Template/RabiesTitrePetHistoryCollection";
import Cytology from "../Template/Cytology";
import FnacHistopathlogyBiopsy from "../Template/FnacHistopathlogyBiopsy";
import FungalStaining from "../Template/FungalStaining";
import USGPregnancyReport from "../Template/USGPregnancyReport";
import USGAbdomenMaleTemplate from "../Template/USGAbdomenTemplate/USGAbdomenMaleTemplate";
import USGAbdomenFemaleTemplate from "../Template/USGAbdomenTemplate/USGAbdomenFemaleTemplate";
import RabiesTitreSerumCollection from "../Template/RabiesTitreSerumCollection";
import DopplerBP from "../Template/DopplerBP";
import ECGReport from "../Template/ECGReport";
const certificates = [
  { id: "1", title: "General Consent Form", sub: "" },
  { id: "2", title: "X-RAY", sub: "" },
  { id: "3", title: "ULTRASOUND", sub: "ULTRASOUND" },
  { id: "4", title: "Feline Immunodeficiency Virus / Feline Leukemia Virus Antigen Test", sub: "Report" },
  { id: "5", title: "Canine Parvo-Corona-Giardia Antigen Kit test", sub: "Report" },
  { id: "6", title: "Ehrlichia-Anaplasa-Babesia-Heartworm Antibody Kit test", sub: "Report" },
  { id: "7", title: "Canine Distemper-Parvo-Corona-Giardia Combo Rapid test", sub: "Report" },
  { id: "8", title: "Feline Panleukopenia-Feline Corona-Giardia Kit test", sub: "Report" },
  { id: "9", title: "Canine Parvo", sub: "Report" },
  { id: "10", title: "Canine Parvo Distemper", sub: "Report" },
  { id: "11", title: "Feline Infectious Peritonitis Antibody Test", sub: "Report" },
  { id: "12", title: "Feline Panleukopenia Antigen Test Kit", sub: "Report" },
  { id: "13", title: "Death Certificate", sub: "Report" },
  { id: "14", title: "EUTHANASIA CONSENT FORM", sub: "Report" },
  { id: "15", title: "FREEDOM FROM DISEASE DECLARATION", sub: "Report" },
  { id: "16", title: "PET HEALTH CUM TRAVEL CERTIFICATE", sub: "Report" },
  { id: "17", title: "MICROCHIPPING CERTIFICATE", sub: "Report" },
  { id: "18", title: "PET VACCINATION CERTIFICATE", sub: "Report" },
  { id: "19", title: "CERTIFICATE OF STERILIZATION", sub: "Report" },
  { id: "20", title: "Boarding and Hospitalisation Agreement", sub: "Report" },
  { id: "21", title: "PET HEALTH CERTIFICATE", sub: "Report" },
  { id: "22", title: "Sedation, or Anaesthesia and Surgery Consent Form", sub: "Report" },
  { id: "23", title: "X-Ray/USG Consent Form", sub: "Report" },
  { id: "24", title: "Blood glucose", sub: "Report" },
  { id: "25", title: "Urine Routine Analysis", sub: "Report" },
  { id: "26", title: "Ear Swab for Mite", sub: "Report" },
  { id: "27", title: "BP measurement", sub: "Report" },
  { id: "28", title: "Skin Scraping Microscopic", sub: "Report" },
  { id: "29", title: "ECHOCARDIOGRAPHY", sub: "Report" },
  { id: "30", title: "Ear Cytology Template", sub: "Report" },
  { id: "31", title: "Skin Cytology Template", sub: "Report" },
  { id: "32", title: "Rabies Titre", sub: "Report" },
  { id: "33", title: "Cytology", sub: "Report" },
  { id: "34", title: "FNAC / HISTOPATHOLOGY / BIOPSY", sub: "Report" },
  { id: "35", title: "Fungal Staining", sub: "Report" },
  { id: "36", title: "USG PREGNANCY REPORT", sub: "Report" },
  { id: "37", title: "USG ABDOMEN MALE", sub: "Report" },
  { id: "38", title: "USG ABDOMEN FEMALE", sub: "Report" },
  { id: "39", title: "Rabies Titre Serum Collection", sub: "Report" },
  { id: "40", title: "BP Report", sub: "Report" },
  { id: "41", title: "ELECTROCARDIOGRAM (ECG) REPORT", sub: "Report" },
];
const PrintCertificate: React.FC<ICertificatesTabProps> = () => {
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });
  const formHook = useForm<any>({
    mode: "onChange",
    defaultValues: {
      certificate_type: "",
      certificate_id: "",
    },
  });
  return (
    <div className="pl-2 ">
      <h2 className="text-xs font-semibold">Vetic Certificate</h2>
      <div className="flex items-center justify-between gap-3 mt-3">
        <div className="min-w-0 flex-1 sm:max-w-md">
          <SearchableSelectMenu
            errorMessages={[{ message: "", type: "required" }]}
            onSelectItem={(item) => {
              if (item) {
                formHook.setValue("certificate_type", item.title);
                formHook.setValue("certificate_id", item.id);
              }
            }}
            fieldError={formHook.formState.errors.reminder_type}
            register={formHook.register("certificate_type", { required: true })}
            selectItems={certificates}
            placeholder="Select Certificate"
            showTooltips={true}
            showTypedErrors={false}
            showDropdownIcon={true}
            defaultSelected={certificates?.filter((oc) => oc.title === formHook.watch("certificate_type"))[0]}
            listBoxClassName="w-full"
            className="text-gray-800 w-full"
            containerClassName="w-full"
          />
        </div>
        <div className="flex shrink-0 justify-end">
          <div className="gap-2 space-x-2">
            <button
              className="px-6 py-2 bg-black text-xs text-white rounded-md border-transparent"
              onClick={() => reactToPrintFn()}
            >
              Print
            </button>
          </div>
        </div>
      </div>
      {formHook.watch("certificate_id") && (
        <div ref={contentRef} className="px-10 print-container">
          <LetterHeader />
          <div className="flex items-center justify-center py-3 flex-col gap-2">
            {formHook.watch("certificate_id") === "2" && (
              <div>
                <p className="text-center font-semibold border-gray-500">{formHook.watch("certificate_type")}</p>
                <p className="text-center font-semibold inline-block border-b-2 border-gray-500">RADIOGRAPHY REPORT</p>
              </div>
            )}
            {formHook.watch("certificate_id") === "3" && (
              <div>
                <p className="text-center font-semibold border-gray-500">{formHook.watch("certificate_type")}</p>
                <p className="text-center font-semibold inline-block border-b-2 border-gray-500">RADIOGRAPHY REPORT</p>
              </div>
            )}
            {formHook.watch("certificate_id") === "1" && (
              <div>
                <p className="text-center font-semibold inline-block border-b-2 border-gray-500">
                  Treatment Consent Form
                </p>
              </div>
            )}
            {formHook.watch("certificate_id") > 3 && (
              <div>
                <p className="text-center font-semibold border-gray-500">{formHook.watch("certificate_type")}</p>
              </div>
            )}
          </div>
          {formHook.watch("certificate_id") === "1" && (
            <div className="pt-2">
              <ConsentForm />
            </div>
          )}
          {formHook.watch("certificate_id") === "2" && (
            <div className="pt-2">
              {" "}
              <RadiographyReport />
            </div>
          )}
          {formHook.watch("certificate_id") === "3" && (
            <div className="pt-0">
              <Ultrasound />
            </div>
          )}
          {formHook.watch("certificate_id") > 3 && formHook.watch("certificate_id") < 13 && (
            <div className="pt-2">
              <RadiographyReport />
            </div>
          )}
          {formHook.watch("certificate_id") === "13" && (
            <div className="pt-3">
              {" "}
              <DeathReport />
            </div>
          )}
          {formHook.watch("certificate_id") === "14" && (
            <div className="pt-3">
              {" "}
              <GeneralConentForm />
            </div>
          )}
          {formHook.watch("certificate_id") === "15" && (
            <div className="pt-3">
              {" "}
              <FreedomDiseaseForm />
            </div>
          )}
          {formHook.watch("certificate_id") === "16" && (
            <div className="pt-3">
              <Pethelthcertificate />
            </div>
          )}
          {formHook.watch("certificate_id") === "17" && (
            <div className="pt-3">
              {" "}
              <Microchipping />
            </div>
          )}
          {formHook.watch("certificate_id") === "18" && (
            <div className="pt-3">
              {" "}
              <PetVaccinationCertificate />
            </div>
          )}
          {formHook.watch("certificate_id") === "19" && (
            <div className="pt-3">
              {" "}
              <StaralizationForm />
            </div>
          )}
          {formHook.watch("certificate_id") === "20" && (
            <div className="pt-2">
              <BoardingAndHospitalization />
            </div>
          )}
          {formHook.watch("certificate_id") === "21" && (
            <div className="pt-3">
              <PethelthcertificateNottravel />
            </div>
          )}
          {formHook.watch("certificate_id") === "22" && (
            <div className="pt-2">
              <SurgeryConsentForm />
            </div>
          )}
          {formHook.watch("certificate_id") === "23" && (
            <div className="pt-2">
              <XrayConsentForm />
            </div>
          )}
          {formHook.watch("certificate_id") === "24" && (
            <div className="pt-2">
              <BloodGlucose />
            </div>
          )}
          {formHook.watch("certificate_id") === "25" && (
            <div className="pt-2">
              <UrinTestForm />
            </div>
          )}
          {formHook.watch("certificate_id") === "26" && (
            <div className="pt-2">
              <RadiographyReport />
            </div>
          )}
          {formHook.watch("certificate_id") === "27" && (
            <div className="pt-2">
              <BPMesaurment />
            </div>
          )}
          {formHook.watch("certificate_id") === "28" && (
            <div className="pt-2">
              <RadiographyReport />
            </div>
          )}
          {formHook.watch("certificate_id") === "29" && (
            <div className="pt-2">
              <Echocardiography />
            </div>
          )}
          {formHook.watch("certificate_id") === "30" && (
            <div className="pt-2">
              <EarCytology />
            </div>
          )}
          {formHook.watch("certificate_id") === "31" && (
            <div className="pt-2">
              <SkinCytology />
            </div>
          )}
          {formHook.watch("certificate_id") === "32" && (
            <div className="pt-2">
              <RabiesTitrePetHistoryCollection />
            </div>
          )}
          {formHook.watch("certificate_id") === "33" && (
            <div className="pt-2">
              <Cytology />
            </div>
          )}
          {formHook.watch("certificate_id") === "34" && (
            <div className="pt-2">
              <FnacHistopathlogyBiopsy />
            </div>
          )}
          {formHook.watch("certificate_id") === "35" && (
            <div className="pt-2">
              <FungalStaining />
            </div>
          )}
          {formHook.watch("certificate_id") === "36" && (
            <div className="pt-2">
              <USGPregnancyReport />
            </div>
          )}
          {formHook.watch("certificate_id") === "37" && (
            <div className="pt-2">
              <USGAbdomenMaleTemplate />
            </div>
          )}
          {formHook.watch("certificate_id") === "38" && (
            <div className="pt-2">
              <USGAbdomenFemaleTemplate />
            </div>
          )}
          {formHook.watch("certificate_id") === "39" && (
            <div className="pt-2">
              <RabiesTitreSerumCollection />
            </div>
          )}
          {formHook.watch("certificate_id") === "40" && (
            <div className="pt-2">
              <DopplerBP />
            </div>
          )}
          {formHook.watch("certificate_id") === "41" && (
            <div className="pt-2">
              <ECGReport />
            </div>
          )}
          <p>
            {" "}
            For any further enquiry, please contact us at <span className="font-bold">8929050010</span>
          </p>
        </div>
      )}
    </div>
  );
};
export default PrintCertificate;
